const cleanText = (text: string): string => {
  return text
    .replace(/\[.*?\]/g, "")
    .replace(/_/g, " ")
    .trim();
};

const toTitleCase = (text: string): string => {
  return cleanText(text)
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const toSentenceCase = (text: string): string => {
  const cleaned = cleanText(text).toLowerCase();
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};

export const formatText = toSentenceCase;
export const formatOrganName = (organ: string): string => toTitleCase(organ);
export const formatFindingName = (finding: string): string => toSentenceCase(finding);
export const formatConditionDisplay = (condition: string): string => {
  const parts = condition.split("/");
  const finding = parts[1] || parts[0];
  return toSentenceCase(finding);
};

/**
 * Truncate text with ellipsis in the middle, showing both beginning and end.
 * Useful for strings like "regulatory-ct-suite-v1.3.5-final" where the
 * distinguishing info is at the end.
 *
 * @param text - The text to truncate
 * @param maxLength - Maximum total length including ellipsis (default 28)
 * @returns Truncated text like "regulatory-ct...v1.3.5-final"
 */
export const middleEllipsis = (text: string, maxLength: number = 28): string => {
  if (text.length <= maxLength) return text;

  const ellipsis = "...";
  const availableChars = maxLength - ellipsis.length;

  // Show more of the end since that's usually the distinguishing part
  const startChars = Math.floor(availableChars * 0.4);
  const endChars = availableChars - startChars;

  return text.slice(0, startChars) + ellipsis + text.slice(-endChars);
};
